import { translate } from 'hooks/useTranslate';
import { axiosV2 } from 'interceptors/axios';
import { downloadBlob } from 'utils/downloadBlob';

type DownloadDividendRequestDocumentProps = {
  operationId: string;
};

export const downloadDividendRequestDocument = async ({
  operationId,
}: DownloadDividendRequestDocumentProps) => {
  const { data } = await axiosV2.get<Blob>(
    '/operations/dividend-request-document',
    { params: { operationId }, responseType: 'blob' }
  );

  downloadBlob(data, `${translate('DividendRequest')}.xlsx`);
};
